module.exports = __webpack_public_path__ + "img/dashboard.ef4d1611.png";